// This file is used on client side via webpack alias in webpack.client
export default window.__WTR_CR_DATA__?.appConfig;
